export default __webpack_public_path__ + "fonts/propstreamlogo-account.svg";